import React from "react";
import { FormattedMessage } from "react-intl";

interface LoaderProps {
    displayLoading: boolean;
}

export const Loader = (props: LoaderProps) => {
    const { displayLoading } = props;
    return (
        <div className={"changesVisualizationLoading"} style={displayLoading ? {} : { visibility: "hidden" }}>
            <FormattedMessage id={"workspaceChanges.loader.title"} />
        </div>
    );
};
